export default __webpack_public_path__ + "static/media/scalable.5d77751e.svg";